export var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel[PermissionLevel["ADMINISTRATOR"] = 80] = "ADMINISTRATOR";
    PermissionLevel[PermissionLevel["AGENT"] = 20] = "AGENT";
})(PermissionLevel || (PermissionLevel = {}));
//# sourceMappingURL=permission-level.enum.js.map